import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import InfiniteScroll from 'react-infinite-scroll-component';
import globalStore from '@/store/global';
import { request } from '@src/common';
import CopyBtn from './copy-btn';
import store from './store';
import modal from './index';
import { HelpOther } from '@/common/helper';

const CodeList = () => {
  // 邀请码是否可用,资源紧张时不可用,置灰
  const inviteCodeValid =
    globalStore.cloudConfig?.assistantMcpServerConfig?.invite_code_valid == 1;
  const inviteCodeDisabledText = globalStore.cloudConfig?.assistantMcpServerConfig?.invite_code_disable_message;

  useEffect(() => {
    store.getInviteCodeList({ init: true });
  }, []);

  const handleCopy = () => {
    const text = `您的专属助力码：
${store.list.filter(({ code, max_uses, used_count }) => !(used_count >= max_uses || !inviteCodeValid)).map(item => item.code).join("\n")}

请访问官方下载页面：
https://bot.n.cn/download?src=AIBotCode

完成以下步骤即可体验全新功能：
1. 下载并安装纳米AI客户端
2. 进入首页或智能体页
3. 在页面右上角点击【输入助力码】按钮，打开弹窗，输入您的专属助力码

成功验证后，您和分享者都将获得${globalStore.cloudConfig?.assistantMcpServerConfig?.invited_count}次额外使用机会！`
    
    navigator.clipboard.writeText(text);
    HelpOther.toast('复制成功');
  };

  return (
    <div className="invite-code w-552px p-24px !pb-19px bg-[#fff] rounded-24px box-border">
      <h3 className="text-24px font-bold-500 mb-0 leading-34px text-[#000]">
        邀请新用户，得更多使用次数
        <span className="text-14px font-normal">
          ({store.invitedCount}/{store.maxInviteCount})
        </span>
      </h3>

      {!inviteCodeValid && inviteCodeDisabledText ? (
        <div className="flex text-14px leading-20px text-black text-opacity-50 mb-24px mt-4px pl-22px" style={{
          background: 'url(https://p3.ssl.qhimg.com/t110b9a9301b1d616e95a2cf87a.png) no-repeat left center',
          backgroundSize: '16px 16px'
        }}>
          {inviteCodeDisabledText}
        </div>
      ) : (
        <div className="flex w-full justify-between items-end pb-24px">
          <div className="pt-4px text-14px leading-20px text-black/50">
            邀请新用户，受邀双方均可获得 
            <span className="font-bold-600">
              {globalStore.cloudConfig?.assistantMcpServerConfig?.invited_count}
              次
            </span>
            限免智能体的使用机会
            <br />
            激活所有助力码，将为您发放新的
          </div>
          <div className="px-16px cursor-pointer h-28px rounded-full border-1px border-black border-opacity-10 text-14px flex items-center hover:bg-black hover:bg-opacity-3 cursor-pointer" onClick={handleCopy}>
            复制全部
          </div>
        </div>
      )}

      {/* 邀请码列表 */}
      <div className="flex items-center justify-start mb-8px text-14px leading-20px font-bold-500 text-black text-opacity-50">
        <span className="w-223px">助力码</span>
        <span className="w-223px">状态</span>
        <span>分享</span>
      </div>
      <ul className="max-h-330px overflow-y-scroll nw-scrollbar-thin" id="invite-code-list">
        {store.list.length > 0 ? (
          <InfiniteScroll
            dataLength={store.list.length}
            next={() => {
              store.getInviteCodeList();
            }}
            hasMore={!!store.npt}
            loader={null}
            scrollableTarget="invite-code-list"
          >
            {store.list.map((item, index) => {
              const { code, max_uses, used_count } = item;
              return (
                <li
                  key={index}
                  className={[
                    'h-60px flex items-center justify-start',
                    'text-14px leading-20px text-black text-align-start',
                    'border-b-1px border-black border-opacity-6 last:border-none',
                    used_count >= max_uses || !inviteCodeValid
                      ? 'opacity-50 pointer-events-none'
                      : '',
                  ]}
                >
                  <span className="font-bold-600 w-223px">{code}</span>
                  <span className="w-223px">
                    {used_count}/{max_uses}
                  </span>
                  <CopyBtn data={{ code }} inviteCodeValid={inviteCodeValid} inviteCodeDisabledText={inviteCodeDisabledText} />
                </li>
              );
            })}
          </InfiniteScroll>
        ) : (
          <li className="h-330px flex items-center justify-center text-14px leading-20px text-black text-opacity-50">
            {store.loaded ? '暂无助力码' : '加载中...'}
          </li>
        )}
      </ul>
    </div>
  );
};

export default observer(CodeList);
